import type { UIStringsOverride } from "../i18n-ui.ts";

/** Hebrew (he) UI strings. */
export const he: UIStringsOverride = {
  actions: {
    addToCursor: "הוסף ל-Cursor",
    addToVscode: "הוסף ל-VS Code",
    askAI: "שאל את ה-AI על העמוד הזה",
    connectMcp: "התחבר ל-MCP",
    copied: "הועתק!",
    copyClaudeCode: "העתק פקודת Claude Code",
    copyCode: "העתק קוד",
    copyCodex: "העתק פקודת Codex",
    copyMarkdown: "העתק כ-Markdown",
    copyServerUrl: "העתק כתובת URL של השרת",
    edit: "ערוך ב-GitHub",
    export: "ייצוא",
    exportEpub: "ייצוא ל-EPUB",
    exportPdf: "ייצוא ל-PDF",
    generating: "מייצר…",
    openIn: "פתח ב-{name}",
    openInChat: "פתח בצ'אט",
    scrollToTop: "חזרה למעלה",
  },
  ask: {
    ai: "AI",
    clear: "נקה שיחה",
    close: "סגור",
    copy: "העתק שיחה",
    empty: "שאל שאלה על התיעוד.",
    error: "מצטערים, משהו השתבש.",
    label: "שאל שאלה",
    placeholder: "שאל שאלה…",
    send: "שלח",
    tip: "טיפ: אפשר לפתוח ולסגור את הצ'אט באמצעות",
    title: "שאל את ה-AI",
    you: "אתה",
  },
  banner: { dismiss: "סגירת ההודעה" },
  changelog: {
    description: "עדכוני מוצר והערות גרסה.",
    showReleases: "הצג גרסאות {version}",
    title: "יומן שינויים",
  },
  content: { diagramError: "לא ניתן להציג את התרשים הזה." },
  feedback: {
    no: "לא",
    question: "האם העמוד הזה היה מועיל?",
    thanks: "תודה על המשוב שלך!",
    yes: "כן",
  },
  languageSwitcher: { label: "שפה", untranslated: "לא מתורגם" },
  nav: {
    back: "חזרה",
    breadcrumb: "פירורי לחם",
    closeNavigation: "סגור ניווט",
    deprecated: "הוצא משימוש",
    featured: "מומלץ",
    githubRepository: "מאגר GitHub",
    navigation: "ניווט",
    primary: "ראשי",
    sections: "מקטעים",
    toggleNavigation: "החלף מצב ניווט",
    toggleTheme: "החלף ערכת צבעים",
  },
  notFound: {
    description: "לא הצלחנו למצוא את העמוד שחיפשת.",
    home: "חזרה לעמוד הבית",
    title: "העמוד לא נמצא",
  },
  page: {
    lastUpdated: "עודכן לאחרונה",
    next: "הבא",
    pagination: "עימוד",
    previous: "הקודם",
    skipToContent: "דלג לתוכן",
  },
  search: {
    all: "הכל",
    allLanguages: "כל השפות",
    askAi: "שאל את ה-AI",
    askAiHint: "קבל תשובה מיידית מה-AI",
    button: "חיפוש",
    devOnly: "החיפוש זמין בבנייה לייצור.",
    error: "משהו השתבש. נסה שוב.",
    label: "חפש בתיעוד",
    navigate: "ניווט",
    noResults: "לא נמצאו תוצאות.",
    open: "פתיחה",
    placeholder: "חפש בתיעוד…",
    popular: "פופולרי",
    preview: "תצוגה מקדימה",
    results: "תוצאות",
  },
  toc: { title: "בעמוד זה" },
};
